<template>

  
    <!-- headline min-vh-100 min-vw-100 d-flex align-items-center justify-content-center position-absolute -->
    <div :id="'statement_' + index" class="headline">
      <h1 class="title">{{ $t(iKey('act_section', 'act_section', 'statement_' + index, 'statement')) }}</h1>
    </div>
  

</template>

<script>
export default {
  name: 'ActStatement',
  props: [
    'item',
    'index'
  ],
  mounted(){
    // var i= this.$props.index
    // var dur = this.windowHeight

    // const scene = this.$scrollmagic.scene({
    //     triggerElement: '#act_wrapper',
    //     triggerHook: 0,
    //     duration: dur,
    //     offset: (dur * i)
    // })
    // this.$scrollmagic.addScene(
    //   scene
    //     //.addIndicators({name: 'statement_' + this.$props.index})
    //     .setClassToggle('#statement_' + this.$props.index, "highlight")
    // )
  }
}
</script>

<style scoped >
h1 {
  background-color: white;
  color: #382e2b;
  display: inline;
  padding: 10px 20px;
  box-decoration-break: clone;
}

.headline {
  visibility: visible;
  top: 0;
  z-index: 10;
}

.headline.highlight {
  visibility: visible;
}

</style>
